import { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { CustomNavigationHeader } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagNavigationHeader = (props: Props) => {
  const { onBack } = props;

  const { formatMessage } = useIntl();

  return (
    <CustomNavigationHeader.Container
      palette="cream"
      buttonsReservedSpace="left"
      safeAreaEdges={SAFE_AREA_EDGES}
    >
      <CustomNavigationHeader.Button.Left
        accessibilityLabel={formatMessage(messages.back)}
        name="IconArrowLeft"
        onPress={onBack}
      />
    </CustomNavigationHeader.Container>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: ComponentProps<typeof CustomNavigationHeader.Container>['safeAreaEdges'] =
  Platform.select({ android: ['top'], default: [] });

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  back: {
    defaultMessage: 'Go back',
    description: 'Add To Bag | Navigation header | Back button a11y label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onBack: () => void;
};
